import { type FC } from 'react';
import cn from 'classnames';
import { type HTMLMotionProps, motion } from 'framer-motion';

import css from './styles.module.scss';

interface FullscreenOverlayWrapperProps extends HTMLMotionProps<'div'> {
  className?: string;
  blur?: string;
  backgroundColor?: string;
}

const FullscreenOverlayWrapper: FC<FullscreenOverlayWrapperProps> = ({
  children,
  className,
  blur = '8px',
  backgroundColor = 'rgba(0, 0, 0, 0.80)',
  ...props
}) => {
  return (
    <motion.div
      {...props}
      style={{
        backdropFilter: `blur(${blur})`,
        backgroundColor,
        ...props.style,
      }}
      className={cn(css.fullscreenOverlay, className)}
    >
      {children}
    </motion.div>
  );
};

export { FullscreenOverlayWrapper };
